import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import Geolocation from "./Geolocation";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Research from "./Research";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Research />} />
      <Route path="geolocation" element={<Geolocation />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
